<template>
      <v-container>
        <h2>
          Other restaurants
        </h2>
        <OtherRestaurants/>
      </v-container>
</template>

<script>
import OtherRestaurants from "../components/infoOtherRestaurants.vue";

export default {
  name: 'info_other_restaurants',
  props: ["text"],
  components: { OtherRestaurants }
}
</script>
